export const NR_EVENT_NAMES = {
  RECONNECTION_ON_FOCUS: 'indstocks_ws_reconnect_on_focus',
  RECONNECT_CONNECTION_IN_PROGRESS:
    'indstocks_ws_reconnect_connection_in_progress',
  RECONNECT_TIMER_EXIST: 'indstocks_ws_reconnect_timer_exist',
  CONNECTION_EXIST_ON_RECONNECT: 'indstocks_ws_connection_exist_on_reconnect',
  MAX_RECONNECTION_ATTEMPTS: 'indstocks_ws_max_reconnection_attempts',
  RECONNECT_ATTEMPT_TRIGGERED: 'indstocks_ws_reconnect_attempt_triggered',
  RECONNECTION_ATTEMPT: 'indstocks_ws_reconnection_attempt',
  INITIALIZE_CONNECTION: 'indstocks_ws_initialize_connection',
  INITIALIZE_CONNECTION_ERROR: 'indstocks_ws_initialize_connection_error',
  CONNECT_SUCCESS: 'indstocks_ws_connect_success',
  CONNECT_ERROR: 'indstocks_ws_connect_error',
  RECONNECT_ATTEMPT: 'indstocks_ws_reconnect_attempt',
  DISCONNECTION: 'indstocks_ws_disconnection',
  DISCONNECTION_ERROR: 'indstocks_ws_disconnection_error',
};
